import { Link } from "react-router-dom";

const InProgressCourses = ({ courses }) => {
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i key={i} className={`fas fa-star ${i <= Math.round(rating) ? "text-warning" : "text-muted"}`}></i>
      );
    }
    return stars;
  };

  return (
    <div className="in-progress-courses">
      <h4 className="section-title mb-4">In Progress Courses</h4>

      {courses.length === 0 ? (
        <p className="text-muted">No in-progress courses.</p>
      ) : (
        courses.map((course) => (
          <Link to={`/course/${course.id}`} key={course.id} className="text-decoration-none course-card">
            <div className="row g-0">
              <div className="col-md-4">
                <img src={course.image || "/placeholder.svg"} alt={course.title} className="course-image" />
              </div>
              <div className="col-md-8">
                <div className="course-content">
                  <div className="course-rating mb-2">
                    <div className="stars me-2">{renderStars(course.rating)}</div>
                    <span className="rating-value">{course.rating.toFixed(2)}</span>
                  </div>

                  <h5 className="course-title mb-3">{course.title}</h5>

                  <div className="course-progress-info mb-3">
                    <span className="text-muted">Completed Lessons: </span>
                    <span className="fw-bold">
                      {course.completedLessons} of {course.totalLessons} lessons
                    </span>
                  </div>

                  <div className="progress-section">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="progress-bar-container">
                        <div className="progress custom-progress">
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: `${course.progressPercentage}%` }}
                            aria-valuenow={course.progressPercentage}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                      <span className="progress-percentage ms-3">{course.progressPercentage}% Complete</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </Link>
        ))
      )}
    </div>
  );
};

export default InProgressCourses;